export const PregledSihtaricaResourceBS: PregledSihtaricaInterface = {
  title: "Pregled sihtarica",
  accessDenied:
    "Nemate pristup pregledu sihtarica. Stranica je dostupna samo menadžerima i šefovima.",
  notLockedYet:
    "Nema odobrenih zapisa za ovaj period. PDF i pregled prikazuju samo zapise koje je menadžer odobrio.",
  branch: "Poslovnica",
  branchPlaceholder: "Odaberite poslovnicu",
  startDate: "Početni datum",
  endDate: "Krajnji datum",
  periodLabel: "Period (mjesec)",
  statusOpen: "Nema odobrenih",
  statusLocked: "Ima odobrenih zapisa",
  viewByWorker: "Po radnicima",
  viewByDay: "Po danima",
  empty: "Nema zapisa za odabrani period.",
  totalHours: "Ukupno",
  colDate: "Datum",
  colWorker: "Radnik",
  colType: "Tip",
  colIn: "Dolazak",
  colOut: "Odlazak",
  colHours: "Sati",
  colNote: "Napomena",
  unapprove: "Poništi odobrenje",
  unapproveOk: "Odobrenje je poništeno.",
  delete: "Obriši",
  deleteConfirm: "Da li ste sigurni da želite obrisati ovaj zapis?",
  deleteOk: "Zapis je obrisan.",
  cancel: "Otkaži",
  actionError: "Akcija nije uspjela.",
  pdf: {
    button: "Download PDF",
    document: {
      name: "Ime i prezime",
      title: "Evidencija radnog vremena",
      odabraniPeriod: "Odabrani period",
      ukupnoVrijeme: "Ukupno sati",
      potpisFooter: "Potpis",
      upisaoFooter: "Odobrio",
      entryType: "Tip evidencije",
      napomena: "Napomena",
      pocetak: "Pocetak",
      pocetakPauze: "Pocetak pauze",
      potpisano: "Potpis",
      zavrsetak: "Zavrsetak",
      zavrsetakPauze: "Zavrsetak pauze",
      tipovi: {
        DEZURA: "Dezura",
        ODSUSTVO: "Odsustvo",
        PRIPRAVNOST: "Pripravnost",
        RADNOVRIJEME: "Radno vrijeme",
        RADUSMJENAMA: "Rad u smjenama",
        TERENSKIRAD: "Terenski rad",
        BOLOVANJE: "Bolovanje",
        SLOBODANDAN: "Slobodan dan",
      },
    },
  },
};

export interface PregledSihtaricaInterface {
  title: string;
  accessDenied: string;
  notLockedYet: string;
  branch: string;
  branchPlaceholder: string;
  startDate: string;
  endDate: string;
  periodLabel: string;
  statusOpen: string;
  statusLocked: string;
  viewByWorker: string;
  viewByDay: string;
  empty: string;
  totalHours: string;
  colDate: string;
  colWorker: string;
  colType: string;
  colIn: string;
  colOut: string;
  colHours: string;
  colNote: string;
  unapprove: string;
  unapproveOk: string;
  delete: string;
  deleteConfirm: string;
  deleteOk: string;
  cancel: string;
  actionError: string;
  pdf: {
    button: string;
    document: {
      name: string;
      title: string;
      odabraniPeriod: string;
      ukupnoVrijeme: string;
      potpisFooter: string;
      upisaoFooter: string;
      entryType: string;
      napomena: string;
      pocetak: string;
      pocetakPauze: string;
      potpisano: string;
      zavrsetak: string;
      zavrsetakPauze: string;
      tipovi: Record<string, string>;
    };
  };
}
